import { render, staticRenderFns } from "./AspacJciMemberRegistrationCreate.vue?vue&type=template&id=516d08c0&scoped=true"
import script from "./AspacJciMemberRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./AspacJciMemberRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./AspacJciMemberRegistrationCreate.vue?vue&type=style&index=0&id=516d08c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d08c0",
  null
  
)

export default component.exports